import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { Role } from "./roles";
import { UserRoleService } from "./user-role-service";

@Injectable()
export class RoleGuard {

    constructor(private userRoleService: UserRoleService, private router: Router) {
    }

    public canActivate(route: ActivatedRouteSnapshot) {
        const allowedRoles: Role[] = route.data["allowedRoles"];

        if (this.userRoleService.hasRoles(allowedRoles)) {
            return true;
        } else {
            this.router.navigate([""]);
            return false;
        }
    }
}
